module.exports = __webpack_public_path__ + "img/school-bus-side-view.c4dbd0eb.png";